import { combineReducers } from "redux";
import Translate from "../translate";
import { UsuarioLoginInfoOut } from "../../model/seguridad";
import { ClientesSecurityDto } from "../../model/clientes";

export enum Actions {
  USER_CHANGED = 'USER_CHANGED',
  CLIENTE_CHANGED = 'CLIENTE_CHANGED',
  LANGUAJE_CHANGED = 'LANGUAJE_CHANGED'
}

export interface IDataStorage {
  languaje?: string;
  user?: UsuarioLoginInfoOut;
  cliente?: ClientesSecurityDto;
}

const InitialSettings : IDataStorage = {
};

const main = (state: IDataStorage = InitialSettings, action: { type: Actions, payload: any }) : IDataStorage => {
  let base = state;
  let initialValue = localStorage.getItem("CNET-STORAGE");
  if (initialValue) base = JSON.parse(initialValue) as IDataStorage;
  base = { ...base, ...{ languaje: Translate.getLocale().code } } as IDataStorage;
  
  switch (action.type) {
    case Actions.USER_CHANGED: 
      base = { ...base, ...{ user: action.payload } }
      break;
    case Actions.CLIENTE_CHANGED: 
      base = { ...base, ...{ cliente: action.payload } }
      break;
    case Actions.LANGUAJE_CHANGED: 
      base = { ...base, ...{ languaje: action.payload } }
      break;
    default: break;
  }

  localStorage.setItem("CNET-STORAGE", JSON.stringify(base));
  return base;
}

export default combineReducers({ main });